import { getWeb3NoAccount } from './web3'

// drpc, one of the site's RPC nodes, rejects batches of more than 3 requests on its free plan
const MAX_BATCH_SIZE = 3

/**
 * Accepts an array of contract method calls and batches them, at most MAX_BATCH_SIZE calls per batch
 *
 * Example:
 *
 * [
 *  contract.method.balanceOf().call,
 *  contract.method.startBlockNumber().call
 * ]
 */
const makeBatchRequest = (calls: any[]) => {
  try {
    const web3 = getWeb3NoAccount()
    const batches = Array.from({ length: Math.ceil(calls.length / MAX_BATCH_SIZE) }, () => new web3.BatchRequest())

    const promises = calls.map((call, index) => {
      return new Promise((resolve, reject) => {
        batches[Math.floor(index / MAX_BATCH_SIZE)].add(
          call.request({}, (err, result) => {
            if (err) {
              reject(err)
            } else {
              resolve(result)
            }
          }),
        )
      })
    })

    batches.forEach((batch) => batch.execute())

    return Promise.all(promises)
  } catch {
    return null
  }
}

export default makeBatchRequest
